import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import home from '../views/Home.vue';
var login = function login() {
  return import('@/views/login/index.vue');
};
var wxLogin = function wxLogin() {
  return import('@/views/login/wxlogin.vue');
};
var bindPhone = function bindPhone() {
  return import('@/views/login/bindphone.vue');
};
var details = function details() {
  return import('@/views/details/index.vue');
};
var classify = function classify() {
  return import('@/views/classify/index.vue');
};
var orderConfirm = function orderConfirm() {
  return import('@/views/order/orderconfirm.vue');
};
var orderDetails = function orderDetails() {
  return import('@/views/order/orderdetails.vue');
};
var payment = function payment() {
  return import('@/views/payment/payment.vue');
};
var paymentWx = function paymentWx() {
  return import('@/views/payment/wxpayment.vue');
};
var paymentSuccess = function paymentSuccess() {
  return import('@/views/payment/paymentsuccess.vue');
};
var orderList = function orderList() {
  return import('@/views/order/orderlist.vue');
};
var card = function card() {
  return import('@/views/card/index.vue');
};
var user = function user() {
  return import('@/views/user/mycenter.vue');
};
var userInfor = function userInfor() {
  return import('@/views/user/userinfor.vue');
};
var address = function address() {
  return import('@/views/user/address.vue');
};
var securitySet = function securitySet() {
  return import('@/views/user/securityset.vue');
};
var invoice = function invoice() {
  return import('@/views/user/invoice.vue');
};
var invoiceEdit = function invoiceEdit() {
  return import('@/views/user/invoiceedit.vue');
};
var exchange = function exchange() {
  return import('@/views/exchange/index.vue');
};
var exchangeList = function exchangeList() {
  return import('@/views/exchange/list.vue');
};
var exchangeDetails = function exchangeDetails() {
  return import('@/views/exchange/details.vue');
};
var exchangeSuccess = function exchangeSuccess() {
  return import('@/views/exchange/success.vue');
};
var grade = function grade() {
  return import('@/views/user/grade.vue');
};
var Comment = function Comment() {
  return import('@/views/evaluate/comment.vue');
};
var evaluateList = function evaluateList() {
  return import('@/views/evaluate/list.vue');
};
var feedback = function feedback() {
  return import('@/views/user/feedback.vue');
};
var notifys = function notifys() {
  return import('@/views/notifys/index.vue');
};
var integral = function integral() {
  return import('@/views/user/integral.vue');
};
var integralDetails = function integralDetails() {
  return import('@/views/user/integralDetails.vue');
};
var bargain = function bargain() {
  return import('@/views/bargain/bargain.vue');
};
var coupon = function coupon() {
  return import('@/views/user/coupon.vue');
};
var special = function special() {
  return import('@/views/special/special.vue');
};
var couponList = function couponList() {
  return import('@/views/classify/couponList.vue');
};
var consumables = function consumables() {
  return import('@/views/consumables/consumables.vue');
};
var consumablesMaterial = function consumablesMaterial() {
  return import('@/views/consumables/consumables-material.vue');
};
var consumablesDetails = function consumablesDetails() {
  return import('@/views/consumables/details.vue');
};
var consumablesOrderDetails = function consumablesOrderDetails() {
  return import('@/views/consumables/order-details.vue');
};
var consumablesOrderList = function consumablesOrderList() {
  return import('@/views/consumables/order-list.vue');
};
var material = function material() {
  return import('@/views/consumables/material.vue');
};
var size = function size() {
  return import('@/views/consumables/size.vue');
};
var infor = function infor() {
  return import('@/views/consumables/infor.vue');
};
var selectTag = function selectTag() {
  return import('@/views/consumables/selecttag.vue');
};
var product = function product() {
  return import('@/views/consumables/product.vue');
};
var materialSuccess = function materialSuccess() {
  return import('@/views/consumables/success.vue');
};
var firstPurchase = function firstPurchase() {
  return import('@/views/activity/firstpurchase.vue');
};
var flashsale = function flashsale() {
  return import('@/views/flashsale/flashsale.vue');
};
var doubleTwelve = function doubleTwelve() {
  return import('@/views/activity/double-twelve.vue');
};
var landingPage = function landingPage() {
  return import('@/views/activity/landing-page.vue');
};
Vue.use(VueRouter);
var routes = [{
  path: '/',
  name: 'home',
  component: home
},
// 注册登录
{
  path: '/login',
  name: 'login',
  component: login
},
// 微信扫码登录
{
  path: '/wxlogin',
  name: 'wxLogin',
  component: wxLogin
}, {
  path: '/details',
  name: 'details',
  component: details
},
// 商品分类
{
  path: '/classify',
  name: 'classify',
  component: classify
}, {
  path: '/user',
  name: 'user',
  component: user
}, {
  path: '/userinfor',
  name: 'userInfor',
  component: userInfor
}, {
  path: '/double-twelve',
  name: 'doubleTwelve',
  component: doubleTwelve
}, {
  path: '/address',
  name: 'address',
  component: address
}, {
  path: '/invoice',
  name: 'invoice',
  component: invoice
}, {
  path: '/invoiceedit',
  name: 'invoiceEdit',
  component: invoiceEdit
},
// 确认订单
{
  path: '/orderconfirm',
  name: 'orderConfirm',
  component: orderConfirm
},
// 订单列表
{
  path: '/order-list',
  name: 'orderList',
  component: orderList,
  meta: {
    keepAlive: true,
    requireAuth: true,
    isBack: false
  }
},
// 订单详情
{
  path: '/order-details',
  name: 'orderDetails',
  component: orderDetails
},
// 购物车
{
  path: '/card',
  name: 'card',
  component: card,
  meta: {
    requireAuth: true
  }
},
// 安全设置
{
  path: '/securityset',
  name: 'securitySet',
  component: securitySet,
  meta: {
    requireAuth: true
  }
},
// 微信扫码用户绑定手机号码
{
  path: '/bindphone',
  name: 'bindPhone',
  component: bindPhone
},
// 微信支付宝支付
{
  path: '/payment',
  name: 'payment',
  component: payment
},
// 微信支付
{
  path: '/paymentwx',
  name: 'paymentWx',
  component: paymentWx
},
// 微信支付
{
  path: '/payment-success',
  name: 'paymentSuccess',
  component: paymentSuccess
},
// 退换货列表
{
  path: '/exchange',
  name: 'exchange',
  component: exchange
},
// 服务单详情
{
  path: '/exchange-details',
  name: 'exchangeDetails',
  component: exchangeDetails
},
// 申请售后成功
{
  path: '/exchange-success',
  name: 'exchangeSuccess',
  component: exchangeSuccess
},
// 退换货列表
{
  path: '/exchange-list',
  name: 'exchangeList',
  component: exchangeList,
  meta: {
    keepAlive: true,
    requireAuth: true,
    isBack: false
  }
},
// 等级中心
{
  path: '/grade',
  name: 'grade',
  component: grade
},
// 我的积分
{
  path: '/integral',
  name: 'integral',
  component: integral
},
// 砍价中心
{
  path: '/bargain',
  name: 'bargain',
  component: bargain
},
// 积分明细
{
  path: '/integralDetails',
  name: 'integralDetails',
  component: integralDetails
},
// 发表评论
{
  path: '/comment',
  name: 'Comment',
  component: Comment
},
// 评价晒图
{
  path: '/evaluation-list',
  name: 'evaluationList',
  component: evaluateList
},
// 意见反馈
{
  path: '/feedback',
  name: 'feedback',
  component: feedback
},
// 消息通知
{
  path: '/notifys',
  name: 'notifys',
  component: notifys
},
// 优惠券
{
  path: '/coupon',
  name: 'coupon',
  component: coupon
},
// 导航主题
{
  path: '/special',
  name: 'special',
  component: special
},
// 优惠券商品列表
{
  path: '/couponList',
  name: 'couponList',
  component: couponList
}, {
  path: '/consumables',
  name: 'consumables',
  component: consumables
}, {
  path: '/consumables-details',
  name: 'consumablesDetails',
  component: consumablesDetails
}, {
  path: '/consumables-orderdetails',
  name: 'consumablesOrderDetails',
  component: consumablesOrderDetails
}, {
  path: '/consumables-orderlist',
  name: 'consumablesOrderList',
  component: consumablesOrderList
}, {
  path: '/consumables-terial',
  name: 'consumablesMaterial',
  component: consumablesMaterial,
  meta: {
    keepAlive: true
  }
}, {
  path: '/erial',
  name: 'material',
  component: material,
  meta: {
    keepAlive: true
  }
}, {
  path: '/erial-size',
  name: 'size',
  component: size
}, {
  path: '/erial-infor',
  name: 'infor',
  component: infor
}, {
  path: '/erial-selecttag',
  name: 'selectTag',
  component: selectTag
}, {
  path: '/erial-product',
  name: 'product',
  component: product,
  meta: {
    keepAlive: true
  }
}, {
  path: '/erial-success',
  name: 'materialSuccess',
  component: materialSuccess
},
// 首购特惠优惠券
{
  path: '/first-purchase',
  name: 'firstPurchase',
  component: firstPurchase
},
// 限时抢购
{
  path: '/flash-sale',
  name: 'flashsale',
  component: flashsale
},
// 活动页
{
  path: '/landing-page',
  name: 'landingPage',
  component: landingPage
}];
var router = new VueRouter({
  mode: 'history',
  // base: '/pc',
  routes: routes
});
export default router;